import { IEventType, IRelevantInfo } from '../types/suscription/history.types';

export interface IBaseHistoryEvent {
  statusName?: string;
  eventType?: IEventType;
  createdAt?: string;
  relevantInfo?: IRelevantInfo;
  toolInspectionId?: number | null;
}

export const createEvent = (name: string, description: string): IBaseHistoryEvent => {
  return { eventType: { name, description } as IEventType };
};
